import { render, staticRenderFns } from "./record-audio-kid.vue?vue&type=template&id=4498d1b1&scoped=true"
import script from "./record-audio-kid.vue?vue&type=script&lang=js"
export * from "./record-audio-kid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4498d1b1",
  null
  
)

export default component.exports